<template>
  <div class="text-center">
    <v-snackbar
      v-model="displaySnackbar"
    >
      {{ signupSuccessMsg }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="toggleSnackbar()"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {

  data() {
    return {
      signupSuccessMsg: "Thanks for signing up! We'll be in touch.",
    };
  },

  computed: mapState([
    'displaySnackbar',
  ]),

  methods: {
    toggleSnackbar() {
      this.$store.dispatch('toggleSnackbar');
    },
  },
};
</script>

<style scoped>

</style>
